module.exports = __webpack_public_path__ + "img/icone-assistencia-funeral-familiar__primary-color.6c30336c.png";